export const srcLatLng2 = [
  { lat: 12.8136, lng: 77.3824 },
  { lat: 12.8136, lng: 77.3825 },
  { lat: 12.8138, lng: 77.3829 },
  { lat: 12.8139, lng: 77.383 },
  { lat: 12.8138, lng: 77.3833 },
  { lat: 12.8139, lng: 77.3834 },
  { lat: 12.814, lng: 77.3834 },
  { lat: 12.8142, lng: 77.3833 },
  { lat: 12.8142, lng: 77.3834 },
  { lat: 12.8141, lng: 77.3835 },
  { lat: 12.8135, lng: 77.3837 },
  { lat: 12.8141, lng: 77.3844 },
  { lat: 12.8145, lng: 77.3851 },
  { lat: 12.815, lng: 77.386 },
  { lat: 12.8152, lng: 77.3863 },
  { lat: 12.8156, lng: 77.3871 },
  { lat: 12.816, lng: 77.3881 },
  { lat: 12.8164, lng: 77.3894 },
  { lat: 12.8166, lng: 77.39 },
  { lat: 12.8162, lng: 77.3901 },
  { lat: 12.8161, lng: 77.3902 },
  { lat: 12.8158, lng: 77.3889 },
  { lat: 12.8154, lng: 77.3877 },
  { lat: 12.815, lng: 77.3867 },
  { lat: 12.8145, lng: 77.3858 },
  { lat: 12.814, lng: 77.385 },
  { lat: 12.813, lng: 77.3837 },
  { lat: 12.8123, lng: 77.383 },
  { lat: 12.8115, lng: 77.3822 },
  { lat: 12.8099, lng: 77.3808 },
  { lat: 12.8095, lng: 77.3804 },
  { lat: 12.8094, lng: 77.3804 },
  { lat: 12.808, lng: 77.3791 },
  { lat: 12.8077, lng: 77.3789 },
  { lat: 12.8075, lng: 77.3788 },
  { lat: 12.8074, lng: 77.3787 },
  { lat: 12.8074, lng: 77.3787 },
  { lat: 12.8071, lng: 77.3783 },
  { lat: 12.8065, lng: 77.3778 },
  { lat: 12.8056, lng: 77.3769 },
  { lat: 12.8051, lng: 77.3764 },
  { lat: 12.8043, lng: 77.3759 },
  { lat: 12.804, lng: 77.3757 },
  { lat: 12.8038, lng: 77.3756 },
  { lat: 12.8033, lng: 77.3752 },
  { lat: 12.8026, lng: 77.3749 },
  { lat: 12.8019, lng: 77.3746 },
  { lat: 12.801, lng: 77.3742 },
  { lat: 12.8001, lng: 77.3739 },
  { lat: 12.7995, lng: 77.3738 },
  { lat: 12.7987, lng: 77.3736 },
  { lat: 12.7979, lng: 77.3735 },
  { lat: 12.7964, lng: 77.3735 },
  { lat: 12.7934, lng: 77.3735 },
  { lat: 12.7915, lng: 77.3735 },
  { lat: 12.7888, lng: 77.3734 },
  { lat: 12.7869, lng: 77.3734 },
  { lat: 12.7863, lng: 77.3733 },
  { lat: 12.7863, lng: 77.3733 },
  { lat: 12.7863, lng: 77.3734 },
  { lat: 12.7867, lng: 77.3735 },
  { lat: 12.7872, lng: 77.3738 },
  { lat: 12.7879, lng: 77.3743 },
  { lat: 12.7884, lng: 77.3747 },
  { lat: 12.7883, lng: 77.3748 },
  { lat: 12.7881, lng: 77.3746 },
  { lat: 12.7872, lng: 77.374 },
  { lat: 12.7867, lng: 77.3736 },
  { lat: 12.7864, lng: 77.3735 },
  { lat: 12.7851, lng: 77.3729 },
  { lat: 12.7846, lng: 77.3726 },
  { lat: 12.7842, lng: 77.3723 },
  { lat: 12.7839, lng: 77.3721 },
  { lat: 12.7826, lng: 77.371 },
  { lat: 12.7825, lng: 77.3707 },
  { lat: 12.7818, lng: 77.3702 },
  { lat: 12.7813, lng: 77.3696 },
  { lat: 12.7807, lng: 77.369 },
  { lat: 12.7803, lng: 77.3686 },
  { lat: 12.7801, lng: 77.3683 },
  { lat: 12.7794, lng: 77.3669 },
  { lat: 12.778, lng: 77.3643 },
  { lat: 12.7773, lng: 77.363 },
  { lat: 12.7768, lng: 77.3619 },
  { lat: 12.7762, lng: 77.3606 },
  { lat: 12.7757, lng: 77.3597 },
  { lat: 12.7755, lng: 77.3593 },
  { lat: 12.7748, lng: 77.3582 },
  { lat: 12.7735, lng: 77.3562 },
  { lat: 12.7722, lng: 77.3542 },
  { lat: 12.772, lng: 77.3538 },
  { lat: 12.7717, lng: 77.3533 },
  { lat: 12.7713, lng: 77.3524 },
  { lat: 12.771, lng: 77.3514 },
  { lat: 12.7707, lng: 77.3505 },
  { lat: 12.7705, lng: 77.3493 },
  { lat: 12.7703, lng: 77.3483 },
  { lat: 12.77, lng: 77.3457 },
  { lat: 12.7698, lng: 77.3439 },
  { lat: 12.7696, lng: 77.3431 },
  { lat: 12.7692, lng: 77.3396 },
  { lat: 12.7691, lng: 77.3389 },
  { lat: 12.769, lng: 77.3385 },
  { lat: 12.7689, lng: 77.3378 },
  { lat: 12.7687, lng: 77.3369 },
  { lat: 12.7686, lng: 77.3366 },
  { lat: 12.7684, lng: 77.3361 },
  { lat: 12.7681, lng: 77.3354 },
  { lat: 12.7678, lng: 77.3346 },
  { lat: 12.7676, lng: 77.3341 },
  { lat: 12.7675, lng: 77.3339 },
  { lat: 12.7673, lng: 77.3336 },
  { lat: 12.7669, lng: 77.3332 },
  { lat: 12.7667, lng: 77.3329 },
  { lat: 12.7645, lng: 77.3304 },
  { lat: 12.764, lng: 77.3299 },
  { lat: 12.7616, lng: 77.3277 },
  { lat: 12.7602, lng: 77.3263 },
  { lat: 12.7592, lng: 77.3254 },
  { lat: 12.7586, lng: 77.3249 },
  { lat: 12.7578, lng: 77.3241 },
  { lat: 12.7576, lng: 77.324 },
  { lat: 12.7574, lng: 77.3237 },
  { lat: 12.7571, lng: 77.3232 },
  { lat: 12.7567, lng: 77.3226 },
  { lat: 12.756, lng: 77.3218 },
  { lat: 12.7546, lng: 77.3199 },
  { lat: 12.7545, lng: 77.3197 },
  { lat: 12.7541, lng: 77.3193 },
  { lat: 12.7534, lng: 77.3187 },
  { lat: 12.7518, lng: 77.3176 },
  { lat: 12.7511, lng: 77.3171 },
  { lat: 12.7486, lng: 77.3152 },
  { lat: 12.7481, lng: 77.3148 },
  { lat: 12.7476, lng: 77.3143 },
  { lat: 12.747, lng: 77.3137 },
  { lat: 12.7465, lng: 77.3131 },
  { lat: 12.7462, lng: 77.3126 },
  { lat: 12.7456, lng: 77.3118 },
  { lat: 12.745, lng: 77.3105 },
  { lat: 12.7448, lng: 77.3101 },
  { lat: 12.7446, lng: 77.3096 },
  { lat: 12.7442, lng: 77.3082 },
  { lat: 12.7439, lng: 77.3069 },
  { lat: 12.7434, lng: 77.3052 },
  { lat: 12.743, lng: 77.3036 },
  { lat: 12.7427, lng: 77.3025 },
  { lat: 12.7416, lng: 77.2984 },
  { lat: 12.7401, lng: 77.2927 },
  { lat: 12.7399, lng: 77.2921 },
  { lat: 12.7399, lng: 77.2916 },
  { lat: 12.7398, lng: 77.2909 },
  { lat: 12.7399, lng: 77.2901 },
  { lat: 12.7399, lng: 77.2894 },
  { lat: 12.74, lng: 77.289 },
  { lat: 12.7402, lng: 77.2886 },
  { lat: 12.7404, lng: 77.288 },
  { lat: 12.7412, lng: 77.286 },
  { lat: 12.7442, lng: 77.2783 },
  { lat: 12.7446, lng: 77.2774 },
  { lat: 12.7459, lng: 77.2743 },
  { lat: 12.7467, lng: 77.2723 },
  { lat: 12.7481, lng: 77.2687 },
  { lat: 12.7496, lng: 77.265 },
  { lat: 12.75, lng: 77.264 },
  { lat: 12.7501, lng: 77.2635 },
  { lat: 12.7502, lng: 77.2628 },
  { lat: 12.7503, lng: 77.262 },
  { lat: 12.7504, lng: 77.2614 },
  { lat: 12.7503, lng: 77.2606 },
  { lat: 12.7501, lng: 77.2594 },
  { lat: 12.7499, lng: 77.2585 },
  { lat: 12.7495, lng: 77.2574 },
  { lat: 12.7494, lng: 77.2573 },
  { lat: 12.7489, lng: 77.2564 },
  { lat: 12.7486, lng: 77.2561 },
  { lat: 12.7481, lng: 77.2554 },
  { lat: 12.7476, lng: 77.2548 },
  { lat: 12.7472, lng: 77.2545 },
  { lat: 12.7462, lng: 77.2536 },
  { lat: 12.7451, lng: 77.2528 },
  { lat: 12.7428, lng: 77.2511 },
  { lat: 12.7412, lng: 77.2498 },
  { lat: 12.7392, lng: 77.2483 },
  { lat: 12.7383, lng: 77.2476 },
  { lat: 12.7373, lng: 77.2469 },
  { lat: 12.7367, lng: 77.2463 },
  { lat: 12.7361, lng: 77.2457 },
  { lat: 12.735, lng: 77.2444 },
  { lat: 12.7319, lng: 77.2409 },
  { lat: 12.7287, lng: 77.2373 },
  { lat: 12.7274, lng: 77.2357 },
  { lat: 12.7267, lng: 77.235 },
  { lat: 12.7264, lng: 77.2348 },
  { lat: 12.7259, lng: 77.2344 },
  { lat: 12.7249, lng: 77.2337 },
  { lat: 12.7235, lng: 77.2328 },
  { lat: 12.723, lng: 77.2324 },
  { lat: 12.7223, lng: 77.232 },
  { lat: 12.7215, lng: 77.2314 },
  { lat: 12.7174, lng: 77.2287 },
  { lat: 12.7168, lng: 77.2283 },
  { lat: 12.7164, lng: 77.228 },
  { lat: 12.7147, lng: 77.2269 },
  { lat: 12.7135, lng: 77.226 },
  { lat: 12.7103, lng: 77.2239 },
  { lat: 12.7073, lng: 77.2219 },
  { lat: 12.7064, lng: 77.2213 },
  { lat: 12.7047, lng: 77.2203 },
  { lat: 12.7031, lng: 77.2194 },
  { lat: 12.7025, lng: 77.2191 },
  { lat: 12.7002, lng: 77.2178 },
  { lat: 12.6992, lng: 77.2172 },
  { lat: 12.6987, lng: 77.2169 },
  { lat: 12.6984, lng: 77.2167 },
  { lat: 12.698, lng: 77.2164 },
  { lat: 12.6971, lng: 77.2155 },
  { lat: 12.6933, lng: 77.2118 },
  { lat: 12.6924, lng: 77.2109 },
  { lat: 12.6921, lng: 77.2105 },
  { lat: 12.6914, lng: 77.2096 },
  { lat: 12.6905, lng: 77.2083 },
  { lat: 12.6886, lng: 77.2056 },
  { lat: 12.6883, lng: 77.2052 },
  { lat: 12.6878, lng: 77.2046 },
  { lat: 12.6873, lng: 77.2042 },
  { lat: 12.6869, lng: 77.2039 },
  { lat: 12.6857, lng: 77.2031 },
  { lat: 12.6834, lng: 77.2017 },
  { lat: 12.6831, lng: 77.2015 },
  { lat: 12.682, lng: 77.2006 },
  { lat: 12.6812, lng: 77.2 },
  { lat: 12.6803, lng: 77.1991 },
  { lat: 12.6784, lng: 77.1972 },
  { lat: 12.6772, lng: 77.196 },
  { lat: 12.676, lng: 77.1946 },
  { lat: 12.6753, lng: 77.1939 },
  { lat: 12.6744, lng: 77.193 },
  { lat: 12.6734, lng: 77.1919 },
  { lat: 12.672, lng: 77.1906 },
  { lat: 12.6714, lng: 77.1901 },
  { lat: 12.671, lng: 77.1898 },
  { lat: 12.6707, lng: 77.1896 },
  { lat: 12.6699, lng: 77.1892 },
  { lat: 12.6695, lng: 77.189 },
  { lat: 12.6687, lng: 77.1888 },
  { lat: 12.668, lng: 77.1886 },
  { lat: 12.6671, lng: 77.1884 },
  { lat: 12.6667, lng: 77.1883 },
  { lat: 12.6662, lng: 77.1881 },
  { lat: 12.6654, lng: 77.1879 },
  { lat: 12.6647, lng: 77.1876 },
  { lat: 12.6638, lng: 77.1872 },
  { lat: 12.6633, lng: 77.1869 },
  { lat: 12.6628, lng: 77.1866 },
  { lat: 12.6624, lng: 77.1863 },
  { lat: 12.662, lng: 77.186 },
  { lat: 12.6612, lng: 77.1853 },
  { lat: 12.6606, lng: 77.1845 },
  { lat: 12.66, lng: 77.1836 },
  { lat: 12.6596, lng: 77.183 },
  { lat: 12.6593, lng: 77.1824 },
  { lat: 12.6583, lng: 77.1803 },
  { lat: 12.6574, lng: 77.1782 },
  { lat: 12.657, lng: 77.1776 },
  { lat: 12.6568, lng: 77.1773 },
  { lat: 12.6566, lng: 77.177 },
  { lat: 12.6562, lng: 77.1766 },
  { lat: 12.6556, lng: 77.1762 },
  { lat: 12.6552, lng: 77.176 },
  { lat: 12.6547, lng: 77.1758 },
  { lat: 12.6543, lng: 77.1757 },
  { lat: 12.6537, lng: 77.1756 },
  { lat: 12.6494, lng: 77.1751 },
  { lat: 12.6489, lng: 77.175 },
  { lat: 12.6482, lng: 77.1748 },
  { lat: 12.6479, lng: 77.1746 },
  { lat: 12.6477, lng: 77.1741 },
  { lat: 12.6475, lng: 77.1737 },
  { lat: 12.6471, lng: 77.1732 },
  { lat: 12.6468, lng: 77.1728 },
  { lat: 12.6463, lng: 77.1725 },
  { lat: 12.646, lng: 77.1722 },
  { lat: 12.6455, lng: 77.1719 },
  { lat: 12.6449, lng: 77.1717 },
  { lat: 12.6447, lng: 77.1714 },
  { lat: 12.6446, lng: 77.1708 },
  { lat: 12.6445, lng: 77.1703 },
  { lat: 12.6437, lng: 77.1659 },
  { lat: 12.6436, lng: 77.1652 },
  { lat: 12.6435, lng: 77.164 },
  { lat: 12.6434, lng: 77.161 },
  { lat: 12.6434, lng: 77.1605 },
  { lat: 12.6433, lng: 77.1602 },
  { lat: 12.6431, lng: 77.1594 },
  { lat: 12.6428, lng: 77.1583 },
  { lat: 12.6426, lng: 77.1583 },
  { lat: 12.6426, lng: 77.1583 },
  { lat: 12.6424, lng: 77.1577 }
]
